// extracted by mini-css-extract-plugin
export default {"layout":"_4c29237adf e373ba9089 dbfc09344d","h_slide":"_754ac42a36","category":"ff2ccc8f45 _3533971f96 b6d3c15f22"};